import { render, staticRenderFns } from "./TimeCount.vue?vue&type=template&id=15233623&scoped=true"
import script from "./TimeCount.vue?vue&type=script&lang=ts"
export * from "./TimeCount.vue?vue&type=script&lang=ts"
import style0 from "./TimeCount.vue?vue&type=style&index=0&id=15233623&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15233623",
  null
  
)

export default component.exports